import * as i0 from "@angular/core";
export class SchoolSignupStore {
}
SchoolSignupStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SchoolSignupStore_Factory() { return new SchoolSignupStore(); }, token: SchoolSignupStore, providedIn: "root" });
export var SchoolSignupStoreKeys;
(function (SchoolSignupStoreKeys) {
})(SchoolSignupStoreKeys || (SchoolSignupStoreKeys = {}));
